import React, { useState } from 'react';
import Button from '../../components/common/Button';
import FormField from '../../components/common/FormField';
import Card from '../../components/common/Card';
import { BankDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface BankFormProps {
  initialValues: BankDTO;
  onSubmit: (data: BankDTO) => void;
  onCancel: () => void;
}

const BankForm: React.FC<BankFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
}) => {
  const [formData, setFormData] = useState<BankDTO>(initialValues);

  
            const validationRules: ValidationRules = {
                    name: [
      { required: true, message: 'Name is required' }
    ],
    branchCode: [
      { required: true, message: 'Branch Code is required' }
    ]
            };

  const { errors, validate } = useFormValidation<BankDTO>(validationRules);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  return (
  <Card>
    <form onSubmit={handleFormSubmit}>
      <div className="mb-4">
                <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Name"
          required={true}
          error={errors.name}
        />
        <FormField
          id="branchCode"
          label="Branch Code"
          type="text"
          value={formData.branchCode || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Branch Code"
          required={true}
          error={errors.branchCode}
        />

      </div>
      <div className="flex justify-end space-x-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Save</Button>
      </div>
    </form>
    </Card>
  );
};

export default BankForm;
